export const engineering = {
  id: 'engineering',
  name: 'Software Engineering',
  sectionOrder: ['summary', 'skills', 'experience', 'projects', 'education'],
  defaultLayout: 'two-column',
  recommendedTemplates: ['modern-ats-pro', 'faang-classic'],
  components: {
    experience: 'experience-impact-v2',
    skills: 'skills-categorized',
    header: 'header-classic'
  }
};
export default engineering;
